"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Const_1 = __importDefault(require("../Const"));
const zod_1 = __importDefault(require("zod"));
const avt = Const_1.default.accessVerificationType;
var AccessVerification;
(function (AccessVerification) {
    AccessVerification.beginParamsSchema = zod_1.default.object({ emailOrPhone: zod_1.default.string(), type: zod_1.default.nativeEnum(avt) });
    AccessVerification.beginReturnSchema = zod_1.default.object({
        accessVerificationId: zod_1.default.string(),
        expiresAt: zod_1.default.coerce.date(),
        resendableAt: zod_1.default.coerce.date(),
    });
    AccessVerification.completeParamsSchema = zod_1.default.object({ accessVerificationId: zod_1.default.string(), code: zod_1.default.string() });
    AccessVerification.completeReturnSchema = zod_1.default.object({ token: zod_1.default.string() });
    class Adapter {
        constructor(params) {
            this.api = params.api;
        }
        begin(params) {
            return __awaiter(this, void 0, void 0, function* () {
                const data = AccessVerification.beginParamsSchema.parse(params);
                const path = "/access-verification";
                const unauthenticated = Array(avt.signIn, avt.signUp).includes(params.type);
                const response = yield this.api.request({ data, method: "POST", path, unauthenticated });
                return AccessVerification.beginReturnSchema.parse(response);
            });
        }
        complete(params) {
            return __awaiter(this, void 0, void 0, function* () {
                const _a = AccessVerification.completeParamsSchema.parse(params), { accessVerificationId } = _a, data = __rest(_a, ["accessVerificationId"]);
                const path = `/access-verification/${accessVerificationId}`;
                const response = yield this.api.request({ data, method: "POST", path, unauthenticated: true });
                return AccessVerification.completeReturnSchema.parse(response);
            });
        }
    }
    AccessVerification.Adapter = Adapter;
})(AccessVerification || (AccessVerification = {}));
exports.default = AccessVerification;
